import { lazy } from "react";

// project imports
import GuestGuard from "utils/route-guard/GuestGuard";
import MinimalLayout from "layout/MinimalLayout";
import NavMotion from "layout/NavMotion";
import Loadable from "ui-component/Loadable";

// login routing
const AuthLogin = Loadable(
  lazy(() => import("views/pages/authentication/authentication3/Login3"))
);
const AuthRegister = Loadable(
  lazy(() => import("views/pages/authentication/authentication3/Register3"))
);
const AuthForgotPassword = Loadable(
  lazy(() =>
    import("views/pages/authentication/authentication3/ForgotPassword3")
  )
);

const ResetPassword = Loadable(
  lazy(() => import("views/pages/authentication/authentication3/ResetPassword"))
);
const OtpVerify = Loadable(
  lazy(() => import("views/pages/authentication/auth-forms/PasswordOtp"))
);

const OtpVerification = Loadable(
  lazy(() => import("views/pages/authentication/auth-forms/OtpVerification"))
);

const PropertyOwnerSignup = Loadable(
  lazy(() =>
    import("views/pages/authentication/auth-forms/PropertyOwnerSignup")
  )
);
const PropertyOwnerOtpVerification = Loadable(
  lazy(() =>
    import("views/pages/authentication/auth-forms/PropertyOwnerOtpVerification")
  )
);

const NewRegistrationOtpVerification = Loadable(
  lazy(() =>
    import(
      "views/pages/authentication/auth-forms/NewRegistrationOtpVerification"
    )
  )
);

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: "/",
  element: (
    <NavMotion>
      <GuestGuard>
        <MinimalLayout />
      </GuestGuard>
    </NavMotion>
  ),
  children: [
    {
      path: "/login",
      element: <AuthLogin />,
    },
    {
      path: "/register",
      element: <AuthRegister />,
    },
    {
      path: "/forgot",
      element: <AuthForgotPassword />,
    },
    {
      path: "/reset-password",
      element: <ResetPassword />,
    },
    {
      path: "/otp-verify",
      element: <OtpVerify />,
    },
    {
      path: "/login-with-phone-number",
      element: <OtpVerification />,
    },
    {
      path: "/login-with-electronic-id",
      element: <PropertyOwnerSignup />,
    },
    {
      path: "/owner-otp-verification",
      element: <PropertyOwnerOtpVerification />,
    },
    {
      path: "/otp-verification",
      element: <NewRegistrationOtpVerification />,
    },
  ],
};

export default LoginRoutes;
